import { ListingOtQuery } from '../../graphql-types';
import { getPrices } from './getPrices';
import { getCapacity } from './getCapacity';
import { getDistanceToOffice } from './getDistanceToOffice';

export type TMinMaxCriterias = {
  prix: {
    min: number;
    max: number;
  };
  capacite: {
    min: number;
    max: number;
  };
  classement: {
    min: number;
    max: number;
  };
  classementBis: {
    min: number;
    max: number;
  };
  distanceFromToursOffice: {
    min: number;
    max: number;
  };
};

export const initMinMaxCriterias = (ots: ListingOtQuery['allIngenieOt']['nodes']) => {
  const prices = getPrices(ots);
  const capacity = getCapacity(ots);
  const getDistanceToToursOffice = getDistanceToOffice(ots);
  return {
    prix: prices,
    capacite: capacity,
    classement: { min: 0, max: 5 },
    classementBis: { min: 1, max: 5 },
    distanceFromToursOffice: getDistanceToToursOffice,
  };
};
